import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FeaturedIcon,
  Icons,
} from '@commenda/kakashi';

const UnsavedChangesModal = ({
  isShown,
  onClose,
  onContinue,
}: {
  isShown: boolean;
  onClose: () => void;
  onContinue: () => void;
}) => {
  return (
    <Dialog open={isShown} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader className="border-b-0 flex flex-col gap-lg items-start">
          <DialogTitle className="flex flex-col ">
            <FeaturedIcon
              icon={<Icons.AlertTriangle />}
              variant="warning"
              size="lg"
            />
          </DialogTitle>
          <div className="flex flex-col gap-xs">
            <h3 className="txt-large-bold text-text-primary">
              Unsaved changes
            </h3>
            <p className="txt-small-regular text-text-secondary">
              You&apos;ve made additions to this information request. If you
              choose to proceed, your progress will be lost.
            </p>
          </div>
        </DialogHeader>

        <DialogFooter className="border-t-0 pt-0">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onContinue}>
            <span>Proceed anyway</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { UnsavedChangesModal };
